<template>
    <div>
        <c-list-card
            :height      = "80"
            :edit        = "false"
            border-width = "pa-2"
            @selected    = "onClick"
            @context     = "onContext"
        >
            <template v-slot:title>
                <div class="card-title title-line">
                    {{ event.elevatorNo }} - {{ event.elevatorType.name }}
                </div>
                <v-spacer />
                <div class="text-right customer-name">
                    {{ event.customer.name }}
                </div>
            </template>
            <template v-slot:body>
                <div class="card-subtitle v-flex">
                    <div class="address-line">
                        {{ event.location.street }}, {{ event.location.zipCode }} {{ event.location.city }}
                    </div>
                    <v-spacer />
                </div>
                <div class="card-subtitle v-flex primary--text">
                    {{ type }} seit {{ formatDate (event.received) }}
                </div>
            </template>
        </c-list-card>


        <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item @click = "onCreate">
                    <v-list-item-title>Störung für Stillstand anlegen</v-list-item-title>
                </v-list-item>
                <v-list-item @click = "onClick(true)">
                    <v-list-item-title>Gehe zur Ereignishistorie der Anlage</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

import CListCard from "@/modules/core/components/utils/CListCard.vue";
import Core from "@/modules/core/service/Core";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PLgsCard",

    props: {
        event: {

        }
    },

    components: {
        CListCard
    },

    mixins: [
    ],


    data: () =>({
        x: null,
        y: null,
        showMenu: false,
    }),

    computed: {
        type () {
            return this.$t("todo.lgs.type." + this.event.state);
        }
    },

    methods: {
        textColor () {
            if (this.delay >= 7) {
                return "error--text"
            }

            return 'primary--text';
        },

        onClick () {
            this.$emit("unit", this.event)
        },

        onCreate () {
            Inc.create (this, [this.event.siteId], 12, {
                    subtype: null,
                    prev   : null,
                    date   : null
                }, this.$t("inc.loading.create"),
                (data) => {
                    Inc.goto(this, data.data.id, this.event.siteId, null, {
                        id  : "standstill",
                        data: this.event
                    });
                },
                (data) => {
                    Core.message.popup(this, data);
                }
            );

        },

        onContext (event) {
            event.preventDefault()
            this.showMenu = false
            this.x = event.clientX
            this.y = event.clientY
            this.$nextTick(() => {
                this.showMenu = true
            })
        },

        formatDate (value) {
            return Core.format.datetime.display(value)
        },
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.card-title {
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>